module.exports = __webpack_public_path__ + "static/media/tree_2.ec286ca9.svg";